export const ACTIVE_OFFERS_LG_SCREEN_MAX_ITEMS = 3;
export const ACTIVE_OFFERS_MD_SCREEN_MAX_ITEMS = 2;
